import { helper } from '@ember/component/helper';
import { capitalize } from '@ember/string';

export function humanizeFieldName([name]: [string]): string {
  return name
    .split('_')
    .map((word) => capitalize(word))
    .join(' ');
}

export default helper(humanizeFieldName);
